import { createRemoteComponent } from '@remote-ui/core';

/**
 * InlineStack is used to lay out a horizontal row of elements. Elements always wrap.
 */
const InlineStack = createRemoteComponent('InlineStack');

export { InlineStack };
